module.exports = __webpack_public_path__ + "static/pfs-mobile-e224f5385e76b11f82498192189d2e3e.png";